import React, { useContext, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Home from "../pages/Home";
import Room from "../pages/Room";
import Login from "./Auth/Login";
import Register from "./Auth/Register";
import identify from "../lib/uniq";
import { SocketContext } from "../contexts/SocketContext";
import { AuthContext } from "../contexts/AuthContext"; // You need an AuthContext
import Profile from "../pages/Profile";
import ConfirmEmail from "./Auth/ConfirmEmail";

const GenericNotFound = () => <div>Not Found</div>;

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { isLoggedIn } = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

const PremiumRoute = ({ component: Component, ...rest }) => {
  const { isLoggedIn, isPremium } = useContext(AuthContext);
  const valid = isLoggedIn && isPremium;

  return (
    <Route
      {...rest}
      render={(props) =>
        valid ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

const Router = () => {
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    identify();
  }, []);
  
  return (
    <>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/register" component={Register} />
        <PremiumRoute exact path="/profile" component={Profile} />
        <Route exact path="/confirmEmail" component={ConfirmEmail} />
        <Route exact path="/" component={Home} />
        <Route exact path="/:id" component={Room} />
      </Switch>
    </>
  );
};

export default Router;
